<div class="login-container">
    <form method="post" class="login-form">
        <h1 class="title">SOCIABLE</h1>
        <input type="email" [(ngModel)]="email" name="email" placeholder="EMAIL" required="required" />
        <input type="password" [(ngModel)]="password" name="password" placeholder="PASSWORD" required="required" />

        <button mat-icon-button class="button" (click)="login()">
            <mat-icon>chevron_right</mat-icon>
        </button>
        <p class="m-4">OR</p>
        <button class="button no-width" (click)="loginMetamask()">Login Metamask
        </button>
    </form>
    <div class="finance-banner">
        <img src="/assets/images/BandaLogos_MTDFGob_DETID_PRTR_INCIBE.png" alt="Logos of MTDFGob, DETID, PRTR, and INCIBE">
    </div>
</div>
